import { Location } from '@angular/common';
import {
  AfterViewInit,
  Component,
  OnInit,
  inject,
  viewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { delay, finalize, map, takeUntil, tap } from 'rxjs/operators';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  CreatePeriodicSmartSmsRecipientCommand,
  CreateSmartSmsRecipientCommand,
  CreateSmartSmsRecipientItemRequest,
  GetEnumValuesDto,
  GetPeriodicSmartSmsRequestByIdDto,
  GetSmartScheduledMessageCalculationsQuery,
  GetSmartSmsRequestByIdDto,
  GetSmartSmsRequestRecipientDto,
  SendTypes,
  SmartRequestTypes,
  SmartScheduledMessageCalculationsDto,
  SmartSmsPeriodType,
  SmartSmsRequestPeriodicPatterns,
  SmartSmsRequestStatus,
  SmartSmsStatus,
  SmsAggregator,
  SmsCp,
  SocialMediaSendDetailModel,
  UpdatePeriodicSmartSmsRequestCommand,
  UseTypes,
} from 'src/app/core/api/models';
import {
  EnumsService,
  ScheduledMessagesService,
  SmartSmsRecipientsService,
  SmartSmsRequestsService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import {
  DialogService,
  DialogStatus,
} from 'src/app/core/services/dialog.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { RoutingStateService } from 'src/app/core/services/routing-state.service';
import { SmartSmsShareMemoryService } from 'src/app/core/services/smart-sms-shareMemory.service';
import { AppSelectedAggregator } from 'src/app/core/types/app-selected-aggregator.type';
import { TabsDynamicComponent } from 'src/app/layout/components/tabs-dynamic/tabs-dynamic.component';
import { DateTimeConfig } from 'src/app/shared/components/date-time-picker/date-time-picker.component';
import { PeriodicDateTimeConfig } from 'src/app/shared/components/periodic-date-time-picker/periodic-date-time-picker.component';
import { PeriodicTypeConfig } from 'src/app/shared/components/periodic-type/periodic-type.component';
import { SmartSendConfirmationMapComponent } from 'src/app/shared/components/smart-send-confirmation-map/smart-send-confirmation-map.component';
import { BaseSendSmsConfig } from '../../sending-system/base/base-send-sms/base-send-sms.component';
import { BaseFormPageComponent } from '../../shared/base/components/base-form-page.component';
import { SmartSendSmsConfirmationComponent } from './smart-send-sms-confirmation/smart-send-sms-confirmation.component';
import { ViewFiltersComponent } from './view-filters/view-filters.component';

@Component({
  selector: 'app-confirm-smart-sms-send',
  templateUrl: './send-smart-sms-confirm-request.component.html',
  styleUrls: ['./send-smart-sms-confirm-request.component.scss'],
  standalone: false,
})
export class SendSmartSmsConfirmPage
  extends BaseFormPageComponent
  implements OnInit, AfterViewInit
{
  //#region properties
  location = inject(Location);
  routingState = inject(RoutingStateService);

  formId: string = 'SendSmartSmsConfirmPageForm';
  model: GetSmartScheduledMessageCalculationsQuery;
  smsBody: string = '';
  socialMediaSendDetailModel: SocialMediaSendDetailModel;
  senderNumber: any = 0;
  senderNumberId: any = null;
  smsCount: number = 0;
  baseSendSmsConfig: BaseSendSmsConfig;
  directDateTimeConfig: DateTimeConfig;

  directSendDateTime: string = '';
  startTimeAtDay: string;
  endTimeAtDay: string;

  calcLoading: boolean = false;
  sendLoading: boolean = false;
  isPeriodicRequest: boolean = false;
  readonly Map = viewChild<SmartSendConfirmationMapComponent>('Map');
  readonly filterViewer = viewChild<ViewFiltersComponent>('filterViewer');
  isDisabled: boolean = true;
  isVisibleHelpPage: boolean = false;
  periodicDateTimeConfig: PeriodicDateTimeConfig;
  isRefreshPage: boolean = false;
  loading: boolean = false;
  isExistsMCI: boolean = false;
  isExistsIrancell: boolean = false;
  isExistsRightel: boolean = false;
  selectedOperator: SmsAggregator;
  updateModel: GetPeriodicSmartSmsRequestByIdDto = null;
  isUpdateMode: boolean = false;
  isShowMap: boolean = true;
  startVal: any;
  endVal: any;
  maxSendCount: number;
  maxDailySendCount: number;
  continueSendIfAnyOperatorHaveError: boolean = false;

  get SendTypes() {
    return SendTypes;
  }
  get UseTypes() {
    return UseTypes;
  }
  get SmsCp() {
    return SmsCp;
  }
  sendDateTime: string;
  selectedMode: AppSelectedAggregator = 'hamrahAval';
  selectedDateTimesForPeriodicPattern: string[] = [];
  periodicPattern: SmartSmsRequestPeriodicPatterns =
    SmartSmsRequestPeriodicPatterns.DaysOfWeek;
  //#endregion

  sentDelayType: SmartSmsPeriodType = SmartSmsPeriodType.Hour;
  sentDelayValue: any = 1;

  periodicTypeConfig: PeriodicTypeConfig;

  periodicEndTime: any;
  periodicStartTime: any;
  isSmartCountAsPercent: boolean = true;
  smartCountPercent: number = 100;
  count: number = 100;
  Model = [];
  appLang: string = 'fa';
  SmsAggregatorsEnumValues: GetEnumValuesDto[] = [];
  operators: Array<SmsAggregator> = [];
  get SmartRequestTypes() {
    return SmartRequestTypes;
  }
  get SmsAggregator() {
    return SmsAggregator;
  }
  showSidePanel: boolean = true;
  isWrongIndex: boolean = false;

  public constructor(
    public dynamicTabService: DynamicTabService,
    public dialogService: DialogService,
    public scheduledMessageService: ScheduledMessagesService,
    public smartSmsRecipientService: SmartSmsRecipientsService,
    public smartRequestService: SmartSmsRequestsService,
    public smartSmsShareMem: SmartSmsShareMemoryService,
    public translate: TranslateService,
    public enumService: EnumsService,
    private tabsDynamicComponent: TabsDynamicComponent
  ) {
    super();
    this.dataLoaded = false;
  }

  initForm(): void {
    this.form = new FormGroup({
      sendDate: new FormControl(''),
      sendTime: new FormControl(''),
      smsBody: new FormControl(
        ''
        // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters)
      ),
      senderNumberId: new FormControl(''),
      socialMediaFileId: new FormControl(''),
      socialMediaApplicationId: new FormControl(''),

      sendDateTime: new FormControl('', []),
      periodTypeValue: new FormControl(''),
      startDatetime: new FormControl(''),
      startTime: new FormControl(''),
      endDatetime: new FormControl(''),
      endTime: new FormControl(''),
      startTimeAtDay: new FormControl(''),
      endTimeAtDay: new FormControl(''),
      maxSendCount: new FormControl(''),
      maxDailySendCount: new FormControl(''),
      continueSendIfAnyOperatorHaveError: new FormControl(''),
      sendDelay: new FormGroup({
        sentDelayType: new FormControl(''),
        sentDelayValue: new FormControl(''),
      }),
    });
  }

  changeValidations(event?) {
    if (event?.smsCp == SmsCp.Mxb && !this.formPageConfig.isEditMode) {
      this.form.get('socialMediaFileId').setValidators(Validators.required);
      this.form.get('smsBody').setValidators([
        Validators.required,
        // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters),
      ]);
      this.form.get('socialMediaFileId').updateValueAndValidity();
      this.form.get('smsBody').updateValueAndValidity();
    } else {
      this.form.get('socialMediaFileId').clearValidators();
      this.form.get('socialMediaFileId').updateValueAndValidity();
    }
    if (!this.isPeriodicRequest) {
      // if (this.Model.length > 0) {
      this.form.get('sendDate').setValidators(Validators.required);
      this.form.get('sendTime').setValidators(Validators.required);
      this.form.get('smsBody').setValidators([
        Validators.required,
        // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters),
      ]);
      this.form.get('senderNumberId').setValidators(Validators.required);
    }
    // }
  }

  disableControls() {
    if (this.updateModel) {
      this.form.get('startDatetime').disable();
      this.form.get('startTime').disable();
    }
  }

  setTimeLimit() {
    try {
      this.form.valueChanges.subscribe((data) => {
        this.startVal = data?.startTimeAtDay;
        this.endVal = data?.endTimeAtDay;
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  configBaseSendSMS() {
    try {
      this.baseSendSmsConfig = {
        title: this.pageVocabs + 'title',
        isEdit: this.formPageConfig.isEditMode,
        msgInfoClassList: 'md:tw-w-1/3 tw-mt-2 offset-md-2',
        sendDateTimeClassList: 'md:tw-w-1/3 tw-mt-2',
        isShowReceivers: false,
        isShowFastSend: false,
        isAddSignature: !this.formPageConfig?.isEditMode ? true : false,
        isAddHeader: !this.formPageConfig?.isEditMode ? true : false,
        isShowPageHeader: false,
        isConvertToIsoString: false,
      };

      this.directDateTimeConfig = {
        dateLabel: this.fields + 'sendDay',
        timeLabel: this.fields + 'sendHour',
        dateFormControl: this.form?.get('sendDate') as FormControl,
        timeFormControl: this.form?.get('sendTime') as FormControl,
        minDateType: 'today',
        isDefaultValue: false,
        isConvertToIsoString: false,
        isEditMode: this.formPageConfig.isEditMode,
        minTimeType: 'now',
        minDate: 'today',
        maxDateType: 'tomorrow',
      };

      this.periodicDateTimeConfig = {
        startDateLabel: 'common.startDate',
        startTimeLabel: 'common.startTime',
        endDateLabel: 'common.endDate',
        endTimeLabel: 'common.endTime',
        startDateFormControl: this.form?.get('startDatetime') as FormControl,
        startTimeFormControl: this.form?.get('startTime') as FormControl,
        endDateFormControl: this.form?.get('endDatetime') as FormControl,
        endTimeFormControl: this.form?.get('endTime') as FormControl,
        isConvertToIsoString: false,
        isEditMode: this.formPageConfig.isEditMode,
        minStartDateType: this.updateModel == null ? 'today' : 'unlimited',
        responsiveClassName: 'md:tw-w-1/2',
        isShowStartDateIconValidation: this.updateModel == null ? true : false,
        endDateTimeValue:
          this.updateModel == null
            ? this.periodicEndTime
            : this.updateModel.periodEnd,
        startDateTimeValue:
          this.updateModel == null
            ? this.periodicStartTime
            : this.updateModel.periodStart,
        minStartTimeTheCurrentTimeIfDateIsToday:
          this.updateModel != null ? false : true,
      };

      this.periodicTypeConfig = {
        periodTypeLabel: this.fields + 'sentDelayType',
        periodTextLabel: this.fields + 'sentDelayValue',
        periodTypeControl: this.form?.get(
          'sendDelay.sentDelayType'
        ) as FormControl,
        periodTextControl: this.form?.get(
          'sendDelay.sentDelayValue'
        ) as FormControl,
        periodText:
          this.updateModel == null
            ? this.sentDelayValue
            : this.updateModel.periodText,
        periodType:
          this.updateModel == null
            ? this.sentDelayType
            : this.updateModel.periodTypeValue,
        isTextParser: false,
        isSmartCampaign: true,
      };

      if (this.formPageConfig.isEditMode) {
        this.baseSendSmsConfig.isEdit = true;
        this.baseSendSmsConfig.justShowDirectDateTimeForEdit = true;
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  data: GetSmartSmsRequestByIdDto;
  dataLoaded: boolean = false;
  loadingError: string = '';
  smartRequestId: number;

  /**
   * this method load smartSmsRequest from server and fill the grid,the map and etc
   * then user can change the number of sms he or she want to send
   * the privateNumberId and smsBody and etc most fill by the user
   * @param id smart sms request id
   */
  loadWithRequestId(id: number) {
    this.smartRequestId = id;
    this.loading = true;
    this.smartRequestService
      .smartSmsRequestsGetSmartSmsRequestById({
        SmartSmsRequestId: id,
      })
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => (this.loading = false))
      )
      .subscribe((res) => {
        try {
          if (this.smartSmsShareMem.getUpdatePeriodicSmartSmsModel()) {
            const { periodicPatterns, validDateTimesForPeriodicPattern } =
              res.data;
            this.periodicPattern = periodicPatterns;
            this.selectedDateTimesForPeriodicPattern =
              validDateTimesForPeriodicPattern || [];
          }
          //var filterData = JSON.parse(res.responseData);
          this.changeValidations();
          if (
            res.data?.smartRequestType ==
              SmartRequestTypes.WelcomeForAirports ||
            res.data?.smartRequestType == SmartRequestTypes.WelcomeForCity ||
            res.data?.smartRequestType == SmartRequestTypes.WelcomeForProvince
          )
            this.isShowMap = false;

          if (
            res.data?.status == SmartSmsRequestStatus.Done ||
            res.data?.status ==
              SmartSmsRequestStatus.PartOfRequestIsCompleted ||
            this.isPeriodicRequest == true
          ) {
            this.dataLoaded = true;
            this.data = res.data;
            const filterViewer = this.filterViewer();
            filterViewer.filters = res.data?.filterEnums;

            let obj = JSON.parse(res.data?.responseData);
            (Object.keys(obj) as (keyof typeof obj)[]).forEach((key, index) => {
              obj[key] = JSON.parse(obj[key]);
            });
            filterViewer.filterToDisplay = obj;
            this.isDisabled = false;
            filterViewer.createDisplayText();
            this.Model = [];

            this.data.recipients.forEach((element) => {
              if (element.operator == SmsAggregator.MCI)
                this.isExistsMCI = true;
              if (element.operator == SmsAggregator.Irancell)
                this.isExistsIrancell = true;
              if (element.operator == SmsAggregator.Rightel)
                this.isExistsRightel = true;
              var item = {
                id: element.id,
                total: element.count,
                sendCount: element.count,
                persianPrice: element.persianPrice,
                englishPrice: element.englishPrice,
                startFrom: 1,
                polygon: [element.coordinates],
                operator: element.operator,
              };
              this.Model.push(item);
            });
            if (this.Model.length > 0) this.Map().setModel(this.Model);
            // this.changeValidations();
          } else {
            this.dataLoaded = false;
          }

          if (!this.dataLoaded) {
            try {
              this.dialogService.openDialog({
                message:
                  this.translate.instant(
                    this.pageVocabs + 'errors.couldNotEditRequest'
                  ) +
                  '<br>' +
                  this.translate.instant(
                    this.pageVocabs +
                      'errors.pleaseWaitUntilTheRequestStateChanged'
                  ),
                status: DialogStatus.error,
              });
            } catch (error) {
              this.loggerService.logError(
                this.tagName,
                error,
                EventTypes.smartSms
              );
            }
          }
        } catch (error) {
          this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
        }
      });
  }
  /**
   * after the view initialized the request id get and fetching data from server
   */
  ngAfterViewInit(): void {}

  ngOnInit(): void {
    try {
      let id = this.smartSmsShareMem.getScheduledMessageId();
      let isPeriodic = this.smartSmsShareMem.getIsPeriodic();
      let scheduledMessageTitle =
        this.smartSmsShareMem.getScheduledMessageTitle();

      if (id > 0) {
        this.location.go(
          window.location.pathname +
            '?' +
            QueryStringTypesEnum.SmartId_key +
            '=' +
            id +
            '&' +
            QueryStringTypesEnum.IsPeriodic_key +
            '=' +
            isPeriodic +
            '&' +
            QueryStringTypesEnum.ScheduledMessageTitle_key +
            '=' +
            scheduledMessageTitle
        );
      } else {
        let params = this.routingState.parseQueryString();
        for (const [key, value] of Object.entries(params)) {
          if (key == QueryStringTypesEnum.SmartId_key) {
            id = +value;
          }
          if (key == QueryStringTypesEnum.IsPeriodic_key) {
            this.isPeriodicRequest = value === 'true';
          }
          if (key == QueryStringTypesEnum.ScheduledMessageTitle_key) {
            this.smartSmsShareMem.setScheduledMessageTitle(value.toString());
          }
        }
      }

      super.ngOnInit();
      this.getEnumsValues();
      this.loading = true;
      this.setTimeLimit();
      let model = this.smartSmsShareMem.getUpdatePeriodicSmartSmsModel();
      if (model) {
        this.maxSendCount = model.maxSendCount;
        this.maxDailySendCount = model.maxDailySendCount;
        this.updateModel = model;
        this.formPageConfig.isEditMode = true;
        this.isUpdateMode = true;
        this.senderNumber = this.updateModel.privateNumberNumber;
        this.isSmartCountAsPercent = this.updateModel.isSmartCountAsPercent;
        if (this.isSmartCountAsPercent)
          this.smartCountPercent = this.updateModel.count;
        else this.count = this.updateModel.count;

        this.disableControls();
      }

      this.pageVocabs = 'pages.confirmSmartSmsRequest.';
      this.fields = this.pageVocabs + 'fields.';
      this.configBaseSendSMS();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }
  getEnumsValues() {
    this.getEnumValuesApi('SmsAggregator')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsAggregatorsEnumValues = values));
  }

  getEnumValuesApi(enumName): Observable<GetEnumValuesDto[]> {
    try {
      return this.enumService
        .enumsGetEnumValues({ EnumTypeName: enumName })
        .pipe(
          takeUntil(this.onDestroy$),
          map((res) => res.data)
        );
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.baseIndexPage
      );
    }
  }
  /**
   * this method open new tab on the user interface with given component name
   * @param tabName
   */
  openPage(tabName: string) {
    try {
      this.dynamicTabService.setNewTab('');
      this.dynamicTabService.setNewTab(tabName);
      this.dynamicTabService.setActiveTab(tabName);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  /**
   * this method called to set the send Date Time value of current form
   * @param $event
   */
  setSendTime($event) {
    try {
      let value = this.form.value;
      value['sendDateTime'] = $event;
      //this line commented because it had error in console "Maximum call stack size exceeded"
      // this.form.setValue(value);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  lastSubmitedRec: GetSmartSmsRequestRecipientDto[] = [];
  /**
   * this method called form the post button click and first generate the calculation command body
   * the call the calculation api at the end
   */
  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.operators.length <= 0) {
      this.dialogService.openDialog({
        title: this.translate.instant('common.error'),
        message: this.translate.instant(
          this.pageVocabs + 'errors.mustSelectOperator'
        ),
        status: DialogStatus.error,
      });
      return;
    }
    if (this.loading) return;
    this.calcLoading = true;
    this.lastSubmitedRec = [];
    if (!this.isWelcomeType()) {
      this.Map()
        .getModel()
        ?.forEach((item) => {
          if (item.sendCount > 0 && this.operators.includes(item.operator)) {
            var nIt: GetSmartSmsRequestRecipientDto = {
              coordinates: item.polygon[0],
              count: item?.sendCount,
              englishPrice: item.englishPrice,
              fromIndex: item?.startFrom == 0 ? 1 : item.startFrom,
              id: item.id,
              persianPrice: item.persianPrice,
              status: SmartSmsStatus.Done,
              operator: item.operator,
            };
            this.lastSubmitedRec.push(nIt);
          }
        });
    } else {
      this.data.recipients?.forEach((item) => {
        if (item.count > 0 && this.operators.includes(item.operator)) {
          var nIt: GetSmartSmsRequestRecipientDto = {
            coordinates: [],
            count: item.count,
            englishPrice: item.englishPrice,
            fromIndex: item.fromIndex == 0 ? 1 : item.fromIndex,
            id: item.id,
            persianPrice: item.persianPrice,
            status: SmartSmsStatus.Done,
            operator: item.operator,
          };
          this.lastSubmitedRec.push(nIt);
        }
      });
    }

    if (this.lastSubmitedRec.length > 0) {
      let body: GetSmartScheduledMessageCalculationsQuery = {};
      body.privateNumberNumber = this.senderNumber;
      body.smsBody = this.smsBody;
      body.recipients = this.lastSubmitedRec;
      body.socialMediaDetails = this.socialMediaSendDetailModel;

      //first fix method in backend then change in front
      this.scheduledMessageService
        .scheduledMessagesGetSmartScheduledMessageCalculations({
          body: body,
        })
        .pipe(
          map((res) => res.data),
          delay(500),
          tap((res: Array<SmartScheduledMessageCalculationsDto>) => {
            if (res) this.onConfirmation(res);
          }),
          this.basePipeOperators(),
          finalize(() => (this.calcLoading = false))
        )
        .subscribe();
    } else {
      this.calcLoading = false;
      this.dialogService.openDialog({
        message: this.translate.instant('common.emptyReceivers'),
        status: DialogStatus.error,
      });
    }
  }
  /**
   * this method called after calculation api called and server return the smartSmsRequest Price info
   * and used to show the confirmation dialog
   * @param model
   */
  onConfirmation(model: Array<SmartScheduledMessageCalculationsDto>) {
    this.unSubs();
    let data = {
      model: model,
      smsCount: this.smsCount,
      sendType: SendTypes.Smart,
      smsAggregators: this.SmsAggregatorsEnumValues,
    };
    const modalResult = this.dialogService.openModal({
      component: SmartSendSmsConfirmationComponent,
      data: data,
    });

    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((confirm) => {
        try {
          let recipients: Array<CreateSmartSmsRecipientItemRequest> = [];
          this.operators.forEach((item) => {
            let recipient: CreateSmartSmsRecipientItemRequest = {};
            let smartRecipients = this.lastSubmitedRec.filter(
              (rec) => rec.operator == item
            );
            if (smartRecipients.length > 0) {
              recipient.smartSmsRecipients = smartRecipients;
              recipient.operator = item;
              recipients.push(recipient);
            }
          });
          if (confirm)
            this.createSmartSmsRecipient({
              recipients: recipients,
              smartSmsRequestId: this.smartRequestId,
              isSendFromFile: false,
              privateNumberNumber: this.senderNumber,
              sendDateTime: this.sendDateTime,
              smsBody: this.smsBody,
              socialMediaDetails: this.socialMediaSendDetailModel,
            });
        } catch (error) {
          this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
        }
      });
  }
  /**
   * this method called after the price confirmation
   */
  //TODO Implementation CreateSmartSmsRecipientGet
  createSmartSmsRecipient(inputModel: CreateSmartSmsRecipientCommand) {
    this.unSubs();
    this.sendLoading = true;
    this.loading = true;
    this.smartSmsRecipientService
      .smartSmsRecipientsCreateSmartSmsRecipientPost({
        body: inputModel,
      })
      .pipe(
        this.basePipeOperators(),
        finalize(() => {
          this.sendLoading = false;
          this.loading = false;
        })
      )
      .subscribe((result) => {
        this.apiNotificationService.notifyMessage({
          result,
          mode: 'matDialog',
        });
        if (result?.isSucceed) {
          this.onSuccess();
          this.refreshPage();
        }
      });
  }

  onShowHelpPage() {
    this.isVisibleHelpPage = true;
  }

  onHideHelpPage() {
    this.isVisibleHelpPage = false;
  }

  onMapLoad() {
    let id = this.smartSmsShareMem.getScheduledMessageId();
    this.isPeriodicRequest = this.smartSmsShareMem.getIsPeriodic();

    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.SmartId_key) {
        id = +value;
      }
      if (key == QueryStringTypesEnum.IsPeriodic_key) {
        this.isPeriodicRequest = value === 'true';
      }
    }

    if (this.isPeriodicRequest) {
      //most set the new validation roles
      this.form.controls['sendDate'].clearValidators();
      this.form.controls['sendTime'].clearValidators();

      this.form.controls['startDatetime'].addValidators([Validators.required]);
      this.form.controls['startTime'].addValidators([Validators.required]);
      this.form.controls['endDatetime'].addValidators([Validators.required]);
      this.form.controls['endTime'].addValidators([Validators.required]);

      // this.form.controls['maxSendCount'].addValidators([Validators.required]);

      (this.form.controls['sendDelay'] as FormGroup).controls[
        'sentDelayType'
      ].addValidators([Validators.required]);
      if (this.updateModel?.periodTypeValue == SmartSmsPeriodType.Minute) {
        (this.form.controls['sendDelay'] as FormGroup).controls[
          'sentDelayValue'
        ].addValidators([Validators.required, Validators.min(10)]);
      } else
        (this.form.controls['sendDelay'] as FormGroup).controls[
          'sentDelayValue'
        ].addValidators([Validators.required]);
    }

    if (id > 0) this.loadWithRequestId(id);
    //end of periodic load
  }

  onCreatePeriodicSmsRecepient() {
    if (this.form.valid) {
      if (this.operators.length <= 0) {
        this.dialogService.openDialog({
          title: this.translate.instant('common.error'),
          message: this.translate.instant(
            this.pageVocabs + 'errors.mustSelectOperator'
          ),
          status: DialogStatus.error,
        });
        return;
      }
      const dialogResult = this.dialogService.confirmDialog({
        isConfirmDelete: false,
        confirmByWritingText: false,
        title: this.translate.instant('messages.globalConfirmationMessage'),
      });

      dialogResult
        .afterClosed()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((result) => {
          if (result) {
            this.pageConfig.loading = true;
            this.createPeriodicSmsRecipientApi();
          }
        });
    }
  }

  createPeriodicSmsRecipientApi() {
    this.sendLoading = true;
    this.loading = true;
    //now most generate the creation model and send it to server
    var modelToPost: CreatePeriodicSmartSmsRecipientCommand = {
      isSmartCountAsPercent: this.isSmartCountAsPercent,
      count: this.isSmartCountAsPercent
        ? Number.parseInt(this.smartCountPercent.toString())
        : Number.parseInt(this.count.toString()),
      smsBody: this.smsBody,
      privateNumberNumber: this.senderNumber,
      periodEnd: this.periodicEndTime,
      periodStart: this.periodicStartTime,
      smartSmsRequestId: this.smartRequestId,
      periodTypeValue: this.sentDelayType,
      periodText: Number.parseInt(this.sentDelayValue.toString()),
      operators: this.operators,
      endTimeAtDay: this.endTimeAtDay,
      startTimeAtDay: this.startTimeAtDay,
      maxSendCount: this.maxSendCount,
      maxDailySendCount: this.maxDailySendCount,
      socialMediaDetails: this.socialMediaSendDetailModel,
      periodicPatterns: this.periodicPattern,
      validDateTimesForPeriodicPattern:
        this.selectedDateTimesForPeriodicPattern,
      continueSendIfAnyOperatorHaveError:
        this.continueSendIfAnyOperatorHaveError,
    };
    this.smartSmsRecipientService
      .smartSmsRecipientsCreatePeriodicSmartSmsRecipientPost({
        body: modelToPost,
      })
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => {
          this.sendLoading = false;
          this.loading = false;
        })
      )
      .subscribe(
        (result) => {
          this.apiNotificationService.notifyMessage({ result });
          if (result.isSucceed) {
            this.formPageConfig.isEditMode = false;
            this.onSuccess();
            this.refreshPage();
            this.isSmartCountAsPercent = true;
            this.smartCountPercent = 100;
          }
        },
        (error) => ConsoleService.error('error', error),
        () => (this.loading = false)
      );
  }

  onUpdatePeriodicSmsRecepient() {
    if (this.form.valid) {
      //now most generate the creation model and send it to server
      var modelToPost: UpdatePeriodicSmartSmsRequestCommand = {
        isSmartCountAsPercent: this.isSmartCountAsPercent,
        count: this.isSmartCountAsPercent
          ? Number.parseInt(this.smartCountPercent.toString())
          : Number.parseInt(this.count.toString()),
        smsText: this.smsBody,
        privateNumberNumber: this.senderNumber,
        periodEnd: this.periodicEndTime,
        //periodStart: this.periodicStartTime,
        smartSmsRequestId: this.smartRequestId,
        periodTypeValue: this.sentDelayType,
        periodText: Number.parseInt(this.sentDelayValue.toString()),
        maxSendCount: this.maxSendCount,
        maxDailySendCount: this.maxDailySendCount,
        startTimeAtDay: this.startTimeAtDay,
        endTimeAtDay: this.endTimeAtDay,
        periodicPatterns: this.periodicPattern,
        validDateTimesForPeriodicPattern:
          this.selectedDateTimesForPeriodicPattern,
        continueSendIfAnyOperatorHaveError:
          this.continueSendIfAnyOperatorHaveError,
      };
      this.smartRequestService
        .smartSmsRequestsUpdatePeriodicSmartSmsRequestPost({
          body: modelToPost,
        })
        .subscribe(
          (result) => {
            this.apiNotificationService.notifyMessage({ result });
            if (result.isSucceed) {
              this.formPageConfig.isEditMode = false;
              this.onSuccess();
              this.dynamicTabService.setNewTab('');
              this.dynamicTabService.setNewTab('smartSend');
              this.dynamicTabService.setActiveTab('smartSend');
              this.tabsDynamicComponent.manualCloseTab(
                'smartSmsRequestConfirmData'
              );
            }
          },
          (error) => ConsoleService.error('error', error),
          () => (this.loading = false)
        );
    }
  }

  refreshPage() {
    this.form.reset();
    this.isRefreshPage = true;
    this.sendDateTime = '';
    this.periodicEndTime = null;
    this.configBaseSendSMS();
    this.tabsDynamicComponent.refreshTab('smartSmsRequestConfirmData');
  }

  sendPeriodicTypePercentateChange($event) {
    this.isSmartCountAsPercent = $event == 0;
  }

  setPeriodicSentPercentage(event: any) {
    this.smartCountPercent = event;
  }

  setPeriodicSendCount(event: any) {
    this.count = this.getNumber(event);
  }

  getSenderNumber(senderNumber) {
    this.senderNumber = senderNumber.number;
  }

  selectOperator(event, operator: SmsAggregator) {
    if (event.checked) this.operators.push(operator);
    else this.operators.splice(this.operators.indexOf(operator), 1);
  }

  addErrorClassToInput(inputElement) {
    this.isWrongIndex = true;
  }

  removeErrorClassFromInput(inputElement) {
    this.isWrongIndex = false;
  }

  changeSelectedOperator(operator: SmsAggregator) {
    this.selectedOperator = operator;
  }

  changeStartFrom(
    item: GetSmartSmsRequestRecipientDto,
    totalCount: number,
    event
  ) {
    let inputElement = <HTMLInputElement>event?.target;

    if (inputElement) {
      item.fromIndex = this.getNumber(event?.target?.value);
      item?.fromIndex == 0 || item?.fromIndex > totalCount
        ? this.addErrorClassToInput(inputElement)
        : item?.fromIndex + item.count > totalCount + 1
        ? this.addErrorClassToBothInput(item.id)
        : this.removeErrorClassFromBothInput(item.id);
    }
  }

  changeCount(item: GetSmartSmsRequestRecipientDto, totalCount: number, event) {
    let inputElement = <HTMLInputElement>event?.target;

    if (inputElement) {
      item.count = this.getNumber(event?.target?.value);
      item?.count == 0 || item?.count > totalCount
        ? this.addErrorClassToInput(inputElement)
        : item?.fromIndex + item.count > totalCount + 1
        ? this.addErrorClassToBothInput(item.id)
        : this.removeErrorClassFromBothInput(item.id);
    }
  }

  async addErrorClassToBothInput(phonebookId) {
    try {
      let fromIndexInput = await this.getFromIndexInputFromDOM(phonebookId);
      let countInput = await this.getCountInputFromDOM(phonebookId);
      this.addErrorClassToInput(fromIndexInput);
      this.addErrorClassToInput(countInput);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  async removeErrorClassFromBothInput(phonebookId) {
    try {
      let fromIndexInput = await this.getFromIndexInputFromDOM(phonebookId);
      let countInput = await this.getCountInputFromDOM(phonebookId);
      this.removeErrorClassFromInput(fromIndexInput);
      this.removeErrorClassFromInput(countInput);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  async getFromIndexInputFromDOM(
    phonebookId: number
  ): Promise<HTMLInputElement> {
    try {
      let countInputElement: HTMLInputElement;

      const formIndexInputs = document.querySelectorAll(
        '[data-from-index-input-id]'
      );
      formIndexInputs.forEach((inputElement) => {
        const DataAttr = inputElement.getAttribute('data-from-index-input-id');
        if (+DataAttr == phonebookId) {
          countInputElement = inputElement as HTMLInputElement;
        }
      });

      return countInputElement;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  async getCountInputFromDOM(phonebookId: number): Promise<HTMLInputElement> {
    try {
      let fromIndexInputElement: HTMLInputElement;

      const toIndexInputs = document.querySelectorAll('[data-count-input-id]');

      toIndexInputs.forEach((inputElement) => {
        const DataAttr = inputElement.getAttribute('data-count-input-id');
        if (+DataAttr == phonebookId) {
          fromIndexInputElement = inputElement as HTMLInputElement;
        }
      });

      return fromIndexInputElement;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  getNumber(num) {
    if (typeof num == 'number') {
      return num;
    }

    let number: Number = +num?.toString()?.getJustNumber();
    if (number) return +number;
    else return 0;
  }

  isWelcomeType(): boolean {
    if (
      this.data.smartRequestType == SmartRequestTypes.WelcomeForAirports ||
      this.data.smartRequestType == SmartRequestTypes.WelcomeForCity ||
      this.data.smartRequestType == SmartRequestTypes.WelcomeForProvince
    )
      return true;
    return false;
  }
  isShowSidePanel(event) {
    this.showSidePanel = event;
  }
  onChangeIsShowContinueSendIfAnyOperatorHaveError(event) {
    this.continueSendIfAnyOperatorHaveError = event.checked;
  }
}
